/** https://github.com/iZettle/izettle-commons/blob/master/src/main/java/com/izettle/commons/enums/IdentityProvider.java */
let IdentityProvider = /*#__PURE__*/function (IdentityProvider) {
  IdentityProvider["IZettle"] = "IZETTLE";
  IdentityProvider["PayPal"] = "PAYPAL";
  IdentityProvider["IzTenant"] = "IZ_TENANT";
  return IdentityProvider;
}({});

export { IdentityProvider };
//# sourceMappingURL=identity-provider.js.map
